import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createIndeedFlexShift,
  type CreateIndeedFlexShiftParams,
} from 'api/admin/indeedFlex/createIndeedFlexShift'
import { indeedFlexKeys } from './keys'

export const useCreateIndeedFlexShiftMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateIndeedFlexShiftParams) =>
      createIndeedFlexShift(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.shiftIssues(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.jobShifts(),
      })
    },
  })
}
